import env from "../../common/env";

export const DEFAULT_COMMENT_MAXIMUM_LENGTH = 100;
export const COMMENT_MAXIMUM_LENGTH =
  env.REACT_APP_COMMENT_MAXIMUM_LENGTH || DEFAULT_COMMENT_MAXIMUM_LENGTH;
